import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './assets/locales/en/translation.json';
import en_jpn from './assets/locales/en-jpn/translation.json';
import ja from './assets/locales/ja/translation.json';
import ja_jpn from './assets/locales/ja-jpn/translation.json';
import th from './assets/locales/th/translation.json';

const translationResources = {
	en: {
		default: en,
		jpn: en_jpn,
	},
	ja: {
		default: ja,
		jpn: ja_jpn,
	},
	th: {
		default: th,
	},
};

const DEFAULT_LANGUAGE = 'en';
const DEFAULT_NAMESPACE = 'default';
const JAPAN_NAMESPACE = 'jpn';

const countryCode = process.env.REACT_APP_COUNTRY_CODE?.toLowerCase() || '';
const namespace = countryCode === JAPAN_NAMESPACE ? JAPAN_NAMESPACE : DEFAULT_NAMESPACE;

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		react: {
			useSuspense: false,
		},
		resources: translationResources,
		lng: DEFAULT_LANGUAGE, // Default language
		ns: [DEFAULT_NAMESPACE, JAPAN_NAMESPACE],
		defaultNS: namespace,
		fallbackLng: false,
		fallbackNS: [DEFAULT_NAMESPACE],
		debug: true,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
